module.exports = __webpack_public_path__ + "img/background041.8901360d.jpg";